import { render, staticRenderFns } from "./contract-view.vue?vue&type=template&id=1ad373b6&scoped=true&"
import script from "./contract-view.vue?vue&type=script&lang=js&"
export * from "./contract-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad373b6",
  null
  
)

export default component.exports